<template>
  <v-flex
    d-flex
    xs4
    sm3
    md2
    lg2
    @click="selectItem"
  >
    <v-card
      :color="getColor"
      ripple
      class="pointer px-1 py-3 text-xs-center"
    >
      <span class="body-2">{{ item.name }}</span>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'FbAudienceCardItem',
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    selected: {
      type: Object,
      default: () => {}
    },
    array: {
      type: String,
      default: ''
    }
  },
  computed: {
    getColor () {
      if (this.selected.name.find(n => n === this.item.name)) return 'green lighten-3'
      return ''
    }
  },
  methods: {
    selectItem () {
      this.$emit('selectItem', this.item, this.array)
    }
  }
}
</script>

<style scoped>
.of-card {
  width: 200px;
  height: 180px;
  cursor: pointer
}
</style>
